
import ConfigPage from '../helpers/ConfigPage';

class OldBrowserMsg {
  constructor() {
    // const
    this.BG_W = 1370;
    this.BG_H = 650;

    // resize vars
    this.sMain = 0;
    this.rW = 0;
    this.rH = 0;

    // parts
    this.msgImg = null;

    // init
    this.init();
  }

  // --------------------------------------------------------------
  // Init
  // --------------------------------------------------------------

  init() {
    this.msgImg = $('<img id="msg-old-browser">');
    this.msgImg.attr('src', `${aPage.pathPrefix}${ConfigPage.PKG_DATA}img/page/msg-old-browser.jpg`);
    $('#main-preloader').append(this.msgImg);

    // add resize lsn
    aPage.signals.resCall.add(this.resUp, this);
    this.resUp();
  }

  // --------------------------------------------------------------
  // Resize
  // --------------------------------------------------------------

  resUp() {
    this.sMain = Math.max(
      aPage.resizer.canvasW / this.BG_W,
      aPage.resizer.canvasH / this.BG_H,
    );
    // set
    this.rW = this.BG_W * this.sMain;
    this.rH = this.BG_H * this.sMain;
    this.msgImg.css({
      width: this.rW,
      height: this.rH,
      top: -(this.rH - aPage.resizer.canvasH) * 0.5,
      left: -(this.rW - aPage.resizer.canvasW) * 0.5,
    });
  }
}

export default OldBrowserMsg;



// WEBPACK FOOTER //
// ./src/js/page/parts/OldBrowserMsg.js